<template>
  <PropertyEditorFactory :editorMeta="editorMeta" :modelValue="binding.value"
    @update:modelValue="v => binding.value = v" />
</template>

<script setup>
/**
 * ConstantBindingEditor.vue
 *
 * Editor for the 'constant' binding strategy — a single scalar value,
 * typed from the widget property's own schema. Resolved and rendered by
 * BindingEditorRouter.vue; never referenced by name from StateBindingsTable.
 */
import { computed } from 'vue';
import { getPropertyEditorMeta } from '../../../automation/schema/PropertyEditorMeta.js';
import PropertyEditorFactory from './PropertyEditorFactory.vue';

const props = defineProps({
  binding:     { type: Object, required: true }, // AutomationBinding — mutated directly
  node:        { type: Object, required: true },
  editorState: { type: Object, required: true }, // BindingEditorState — unused here, kept for a uniform editor prop shape
});

const editorMeta = computed(() => getPropertyEditorMeta(props.node.schemaV2, props.binding.property));
</script>
